import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  FormControl,
  Select,
  InputLabel,
  TextField,
  MenuItem,
  Button,
  Paper,
  Box,
} from '@mui/material';
import {
  Campaign as CampaignIcon,
  Save as SaveIcon,
  ArrowBack as ArrowBackIcon,
  Description as DescriptionIcon,
  Business as BusinessIcon,
  Public as PublicIcon,
  EmojiObjects as EmojiObjectsIcon,
  AttachMoney as AttachMoneyIcon,
  Category as CategoryIcon,
  ToggleOn as ToggleOnIcon,
  Notes as NotesIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store.js';
import {
  obtenerTiposCampanas,
  registrarCampana,
} from '../../../actions/CampanasAction.js';
import { RegistrarAccion } from '../../../actions/AuditoriaAction.js';
export default function NuevaCampana(props) {
  const mounted = useRef(true);
  const [campana, setCampana] = useState({
    id: '',
    CODCAMPANA: 0,
    DESCRICAMPANA: '',
    NUMCAMPANA: '',
    ESTADOCAMPANA: '',
    EMPRESACONTRATADA: '',
    OBJETIVOS: '',
    PRESUPUESTO: '',
  });
  const [geografia, setGeografia] = useState('');
  const [Datag, setDatag] = useState([]);
  const [Datatc, setDatatc] = useState([]);
  const [tipocampana, setTipoCampana] = useState('');
  const [estadocampana, sertEstadoCampana] = useState('');
  //eslint-disable-next-line
  const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();

  const selectTipohandleChange = (event) => {
    setTipoCampana(event.target.value);
  };
  const selectGeografiaHandleChange = (event) => {
    setGeografia(event.target.value);
  };
  const selectEstadohandleChange = (event) => {
    sertEstadoCampana(event.target.value);
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCampana((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const guardarCampana = (e) => {
    e.preventDefault();
    const objetoCampana = {
      CODCAMPANA: parseInt(campana.CODCAMPANA),
      DESCRICAMPANA: campana.DESCRICAMPANA,
      NUMCAMPANA: campana.NUMCAMPANA,
      ESTADOCAMPANA: estadocampana,
      TIPOCAMPANA_Id: tipocampana,
      EMPRESACONTRATADA: campana.EMPRESACONTRATADA,
      GEOGRAFIA: geografia,
      OBJETIVOS: campana.OBJETIVOS,
      PRESUPUESTO: parseInt(campana.PRESUPUESTO),
    };
    registrarCampana(objetoCampana).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se guardo exitosamente la Campaña',
          },
        });
        setCampana({
          id: '',
          CODCAMPANA: 0,
          DESCRICAMPANA: '',
          NUMCAMPANA: '',
          ESTADOCAMPANA: '',
          EMPRESACONTRATADA: '',
          OBJETIVOS: '',
          PRESUPUESTO: 0.0,
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Registro',
          panel: 'Marketing',
          tabla: 'CAMPAÑAS',
          filaafectada: 'NUEVO REGISTRO',
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
        volver();
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    if (mounted.current) {
      setDatag([
        { geografia: 'Local' },
        { geografia: 'Regional' },
        { geografia: 'Nacional' },
        { geografia: 'Internacional' },
      ]);
      obtenerTiposCampanas().then((response) => {
        if (response.status === 200) {
          setDatatc(response.data);
        } else {
          console.log('NO CARGO TIPOS CAMPNANAS');
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <CampaignIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nueva Campaña
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Registra una nueva campaña de marketing en el sistema
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información de la Campaña */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 4, fontWeight: 600 }}>
          Información de la Campaña
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <TextField
              name="DESCRICAMPANA"
              value={campana.DESCRICAMPANA}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Descripción"
              fullWidth
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                    <DescriptionIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="EMPRESACONTRATADA"
              value={campana.EMPRESACONTRATADA}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Empresa Contratada"
              fullWidth
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                    <BusinessIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Geografía</InputLabel>
              <Select
                value={geografia}
                onChange={selectGeografiaHandleChange}
                label="Geografía"
                startAdornment={
                  <Box sx={{ ml: 1.5, mr: 1, display: 'flex', alignItems: 'center' }}>
                    <PublicIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                }
              >
                <MenuItem value="">
                  <em>Ninguna</em>
                </MenuItem>
                {Datag.map((geografia) => (
                  <MenuItem key={geografia.geografia} value={geografia.geografia}>
                    {geografia.geografia}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBJETIVOS"
              value={campana.OBJETIVOS}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Objetivos"
              fullWidth
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                    <EmojiObjectsIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="PRESUPUESTO"
              value={campana.PRESUPUESTO}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Presupuesto"
              type="number"
              fullWidth
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                    <AttachMoneyIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Tipo de Campaña</InputLabel>
              <Select
                value={tipocampana}
                onChange={selectTipohandleChange}
                label="Tipo de Campaña"
                startAdornment={
                  <Box sx={{ ml: 1.5, mr: 1, display: 'flex', alignItems: 'center' }}>
                    <CategoryIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                }
              >
                <MenuItem value="">
                  <em>Ninguna</em>
                </MenuItem>
                {Datatc.map((tipocampana) => (
                  <MenuItem
                    key={tipocampana.tipocampanA_Id}
                    value={tipocampana.tipocampanA_Id}
                  >
                    {tipocampana.descritipocampana}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select
                value={estadocampana}
                onChange={selectEstadohandleChange}
                label="Estado"
                startAdornment={
                  <Box sx={{ ml: 1.5, mr: 1, display: 'flex', alignItems: 'center' }}>
                    <ToggleOnIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                }
              >
                <MenuItem value="Activo">
                  <em>Activo</em>
                </MenuItem>
                <MenuItem value="Inactivo">
                  <em>Inactivo</em>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              name="NUMCAMPANA"
              value={campana.NUMCAMPANA}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              label="Detalles"
              placeholder="Ingrese los detalles de la campaña..."
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>
                    <NotesIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={guardarCampana}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Registrar Campaña
        </Button>
      </Box>
    </Container>
  );
}
